// extracted by mini-css-extract-plugin
export default {"label":"visaInfo-module__label__nLiEh","mobileLabel":"visaInfo-module__mobileLabel__heMEc","icon":"visaInfo-module__icon__urMRW"};